<script>
	export default {
		props: {
			leaflet: {
				type: Object,
				required: true
			},
			map: {
				type: Object,
				required: true
			},
			geometryJson: {
				type: Object,
				required: true
			},
			maskConfig: {
				type: Object
			}
		},
		mounted() {
			const defaultConfig = {
				fillOpacity: 1,
				fillColor: '#fff',
				drawBorder: true,
				borderColor: '#0B9096',
				borderWidth: 3,
				borderOpacity: 1,
				borderLineCap: 'round',
				borderLineJoin: 'round',
				padding: 1,
				pane:'tilePane',//необходимо чтобы управлять zIndex в общем родителе для всех слоев, иначе маску не поставить подниз
				zIndex:0
			};

			const config = Object.assign(defaultConfig, this.maskConfig);

			const maskCanvas = this.leaflet.canvas(config);

            function drawBackGround() {
				if (!this.options.fillOpacity)
					return;
				this._ctx.clearRect(this._bounds.min.x, this._bounds.min.y, this._container.width, this._container.height);
				this._ctx.globalAlpha = this.options.fillOpacity;
				this._ctx.fillStyle = this.options.fillColor;
				this._ctx.fillRect(this._bounds.min.x, this._bounds.min.y, this._container.width, this._container.height);
			}
			
			function drawHole(ctx) {
				this._ctx.globalCompositeOperation = "destination-out";//меняем режим рисования чтобы нарисовать дырку
				ctx.globalAlpha = 1;
				ctx.fillStyle = '#000';//черная заливка делает дырку в геометрии
				ctx.fill('evenodd');
			}

			function drawBorder(ctx) {
				if (this.options.drawBorder && this.options.borderWidth !== 0) {
					ctx.globalAlpha = this.options.borderOpacity;
					ctx.lineWidth = this.options.borderWidth;
					ctx.strokeStyle = this.options.borderColor;
					ctx.lineCap = this.options.borderLineCap;
					ctx.lineJoin = this.options.borderLineJoin;
					ctx.stroke();
				}
			}

			//запоминаем оригинальный метод и переопределяем его реализацию собственной чтобы canvas рисовал то что мы хотим
			const _drawBase = maskCanvas._draw;

			maskCanvas._draw = function () {
				drawBackGround.call(this);
				
				maskCanvas._fillStroke = drawHole;//подменяем исходный метод рисования чтобы нарисовать дырку
				_drawBase.call(this);

				this._ctx.globalCompositeOperation = "source-over";//восстанавливаем рисование в нормальный режим
				maskCanvas._fillStroke = drawBorder;//подменяем исходный метод рисования чтобы нарисовать границу			
				_drawBase.call(this);
			};

			//добавляем на canvas данные на основе JSON-а геометрии
			this.leaflet.geoJSON(this.geometryJson, {
				renderer: maskCanvas,
				interactive:false
			}).addTo(this.map);

			//меняем zIndex если компонент добавился в разметку
			if(maskCanvas._container)
				maskCanvas._container.style.zIndex = config.zIndex;			
		},
		render() {
			return this.$slots.default;
		},
	};
</script>